export const BOM_STATUSES = [
  { key: "yet_to_order", label: "Not Ordered", tone: "gray" },
  { key: "ordered", label: "Order Placed", tone: "gold" },
  { key: "transit", label: "In Transit", tone: "gold" },
  { key: "delivered", label: "Received", tone: "emerald" },
  { key: "hold", label: "On Hold", tone: "amber" },
  // Legacy keys kept so historical rows still render with a readable label.
  { key: "payment_pending", label: "Payment Pending", tone: "amber" },
  { key: "discontinued", label: "Discontinued", tone: "red" },
];

export const CNC_WORKFLOW = [
  { key: "yet_to_start", label: "Yet to Start", tone: "gray" },
  { key: "in_progress", label: "In Progress", tone: "gold" },
  { key: "completed", label: "Completed", tone: "emerald" },
  { key: "dispatched", label: "Dispatched", tone: "emerald" },
];

export const BOM_LABEL = Object.fromEntries(BOM_STATUSES.map((s) => [s.key, s.label]));
export const CNC_LABEL = Object.fromEntries(CNC_WORKFLOW.map((s) => [s.key, s.label]));

export function bomTone(key) {
  return BOM_STATUSES.find((s) => s.key === key)?.tone || "gray";
}
export function cncTone(key) {
  return CNC_WORKFLOW.find((s) => s.key === key)?.tone || "gray";
}

export function pillClass(tone) {
  return ({
    gray:    "text-gray-400  border-[#262626]        bg-[#0a0a0a]",
    gold:    "text-[#d4af37] border-[#d4af37]/40     bg-[#d4af37]/5",
    amber:   "text-amber-400 border-amber-500/40     bg-amber-500/5",
    emerald: "text-emerald-400 border-emerald-500/40 bg-emerald-500/5",
    red:     "text-red-400 border-red-500/40         bg-red-500/5",
  })[tone] || "text-gray-400 border-[#262626] bg-[#0a0a0a]";
}
